import { render, staticRenderFns } from "./DictionaryTypes.vue?vue&type=template&id=04e62446&"
import script from "./DictionaryTypes.vue?vue&type=script&lang=js&"
export * from "./DictionaryTypes.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports